import React from "react";

const SvgComponent = props => (
  <svg width={43.343} height={25.562} viewBox="0 0 43.343 25.562" {...props}>
    <path
      d="M35.771 25.562a7.57 7.57 0 0 0 7.57-7.57s.039-7.563-7.92-7.563C33.7 3.341 27.07 2.983 25.21 3.484 23.193 1.474 19.836 0 16.441 0 9.709 0 4.193 5.205 3.697 11.811A7.36 7.36 0 0 0 0 18.195a7.366 7.366 0 0 0 7.365 7.367h28.406z"
      fill="#83a5b3"
    />
  </svg>
);

export default __webpack_public_path__ + "static/media/04n.a8ffe7ce.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/weather-icons/04n.svg